const CRAFTSMAN_CHANNEL_SECTIONS = {
  HOUSE_CHATS: 'Chats mit Haus',
  INTERNAL_CHATS: 'Interne Chats',
};

export default CRAFTSMAN_CHANNEL_SECTIONS;
